class UpdateAddressModalCtrl {

    constructor(Contact, contactId, invoiceId, $scope, $rootScope, Invoice, $http, Env, Error, SweetAlert, $uibModalInstance) {
        this.currentContactId = contactId;
        this.currentInvoiceId = invoiceId;
        this.contactModel = Contact;
        this.invoiceModel = Invoice;
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.api = $http;
        this.env = Env;
        this.error = Error;
        this.sweetAlert = SweetAlert;
        this.modalInstance = $uibModalInstance;

        this.model = {
            address: ''
        };
        this.contact = {};
        this.invoice = {};
        this.address_type = 'custom';
        this.addressEditable = false;

        this.loadInvoice();
        this.loadContact();
        this.initWatchers();
    }

    loadContact() {
        this.contactModel.one(this.currentContactId).get().then((contact) => {
            this.contact = contact.plain();
        });
    }

    loadInvoice() {
        this.invoiceModel.one(this.currentInvoiceId).get().then((invoice) => {
            this.invoice = invoice.plain();
            this.model.address = _.cloneDeep(this.invoice.address);
        });
    }

    initWatchers() {
        this.scope.$watch(() => {
            return this.address_type;
        }, (value) => {
            this.updateAddress(value);
        });
    }

    updateAddress(value) {
        this.addressEditable = (value === 'custom');

        if (!this.contact) {
            return;
        }

        if (value !== 'custom') {
            let addressPrefix;
            switch (value) {
                case 'preferred':
                    addressPrefix = 'preferred_';
                    break;
                case 'private':
                    addressPrefix = '';
                    break;
                case 'business':
                    addressPrefix = 'business_';
                    break;
            }

            let address = '';
            if (value === 'business' || (value === 'preferred' && this.contact.business_preferred)) {
                address += (this.contact.company_name).trim();
                if (address !== '') {
                    address += "\n";
                }
                address += 'z. H. ' + (this.contact.title + ' ' + this.contact.first_name + ' ' + this.contact.last_name).trim() + "\n";
            } else if (value === 'shipping' && this.contact.shipping_company_name !== '') {
                address += (this.contact.shipping_company_name).trim();
                address += 'z. H. ' + (this.contact.title + ' ' + this.contact.first_name + ' ' + this.contact.last_name).trim() + "\n";
            } else {
                address += (this.contact.title + ' ' + this.contact.first_name + ' ' + this.contact.last_name).trim() + "\n";
            }

            address += this.contact[addressPrefix + 'street'] + "\n";
            if (this.contact[addressPrefix + 'street_2']) {
                address += this.contact[addressPrefix + 'street_2'] + "\n";
            }
            address += this.contact[addressPrefix + 'zip'] + ' ' + this.contact[addressPrefix + 'city'] + "\n";

            let countryName = '',
                currentCountryCode = this.contact[addressPrefix + 'country'];
            if (currentCountryCode) {
                currentCountryCode = currentCountryCode.toUpperCase();
            }
            if (currentCountryCode !== 'DE') {
                _.forEach(this.rootScope.deposit.countries, function (country) {
                    if (country.code === currentCountryCode) {
                        countryName = country.name;
                    }
                });
            }
            address += (countryName + "\n").trim();

            this.model.address = address;
        }
    }

    close() {
        this.modalInstance.close();
    }

    dismiss() {
        this.modalInstance.dismiss();
    }

    save() {
        this.api.put(this.env.apiUrl.concat('/billing/invoices/', this.invoice.id, '/address'), {
            address: this.model.address
        }).then(() => {
            this.sweetAlert.success('update', 'address updated successfully');
            this.close();
        }, (error) => {
            this.error.default(error);
        });
    }
}

UpdateAddressModalCtrl.$inject = [
    'Contact',
    'contactId',
    'invoiceId',
    '$scope',
    '$rootScope',
    'Invoice',
    '$http',
    'Env',
    'Error',
    'SweetAlert',
    '$uibModalInstance',
];

/**
 * @ngdoc object
 * @name billing.invoices.controller:InvoicesCreateModalCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('InvoicesUpdateAddressModalCtrl', UpdateAddressModalCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/update-address-modal-controller.js